import type { IconNode } from '../types';

/**
 * @name coffeemaker
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMjJWMTJhMiAyIDAgMCAwLTItMkg0YTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDE2YTIgMiAwIDAgMSAyIDJ2MThIMiIgLz4KICA8cGF0aCBkPSJNMTAgMnYyYTIgMiAwIDEgMS00IDBWMiIgLz4KICA8cGF0aCBkPSJNMjIgNmgtNCIgLz4KICA8cGF0aCBkPSJNMjIgMTBoLTQiIC8+CiAgPHBhdGggZD0iTTE4IDIydi02YTIgMiAwIDAgMSAyLTJoMiIgLz4KICA8cGF0aCBkPSJNNyAxMHYyIiAvPgogIDxwYXRoIGQ9Ik03IDIyYy0xLjcgMC0zLTEuMy0zLTN2LTNoNnYzYzAgMS43LTEuMyAzLTMgMyIgLz4KICA8cGF0aCBkPSJNMiAxOGEyIDIgMCAwIDEgMi0yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/coffeemaker
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const coffeemaker: IconNode = [
  [
    'path',
    {
      d: 'M14 22V12a2 2 0 0 0-2-2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v18H2',
      key: '2eluyn',
    },
  ],
  ['path', { d: 'M10 2v2a2 2 0 1 1-4 0V2', key: '1y3ii0' }],
  ['path', { d: 'M22 6h-4', key: '9e44og' }],
  ['path', { d: 'M22 10h-4', key: 'bunsuf' }],
  ['path', { d: 'M18 22v-6a2 2 0 0 1 2-2h2', key: 'k8leic' }],
  ['path', { d: 'M7 10v2', key: 'nd14rp' }],
  ['path', { d: 'M7 22c-1.7 0-3-1.3-3-3v-3h6v3c0 1.7-1.3 3-3 3', key: '4lcpni' }],
  ['path', { d: 'M2 18a2 2 0 0 1 2-2', key: 'wtng7l' }],
];

export default coffeemaker;
